//import { LineStyle, LineType, IChartApi, LineData, ISeriesApi, SeriesPartialOptions, LineStyleOptions, LineWidth } from "lightweight-charts"
import { WaveType, WaveDirection } from './WaveComputer';

import { SeriesPartialOptions, LineStyleOptions, priceExtendedType, ExtensionType } from './lcharts/src/model/series-options';
import { LineStyle, LineType, ISeriesApi, IChartApi, LineData, LineWidth } from './lcharts/src/api/create-chart';
import { SeriesMarker } from './lcharts/src/model/series-markers';
import { Time } from './lcharts/src/api/data-consumer';
import { lineSettings } from './RetracementSettings';
import { DrawingService, SeriesTypes } from 'src/app/Services/DrawingService';

export class LineWave
{
    color: string;
    lineStyle: LineStyle;
    lineWidth: 1;
    crosshairMarkerVisible: false;
    crosshairMarkerRadius: 0;
    lineType: LineType.Simple;
    _lineSeries: ISeriesApi<"Line">;
    _pernamentLineWidth:number = 3;

    public markers: SeriesMarker<Time>[] = [];

    constructor(private chart: IChartApi, data: LineData[], pernamentLineWidth:number, wavetype?:WaveType, wavedirection?:WaveDirection, noLastValues?:boolean,private drawingService?:DrawingService)
    {

      let marker;
      this._pernamentLineWidth = pernamentLineWidth;
          if(!wavetype)
          {
            if(!noLastValues)
            {
              this._lineSeries = this.chart.addLineSeries(this.standardSerieOptions(),0);
           //   this.drawingService.markColors.push({index:this._lineSeries.getSerieIndex(),color:this._lineSeries.options().color});
            }
            else
            {
              let op = this.standardSerieOptions();
              op.lastValueVisible = false;
              op.priceLineVisible = false;
              this._lineSeries = this.chart.addLineSeries(op ,0);
            }
          }

          if(wavetype)
          {
            switch(wavetype)
            {
              case(WaveType.PERNAMENT):
              this._lineSeries = this.chart.addLineSeries( this.pernamentSerieOptions(wavedirection),0);

             // this.drawingService.mapSeries.push({index:this._lineSeries.getSerieIndex(),color:this._lineSeries.options().color, type:SeriesTypes.PERNAMENT});
              this.drawingService.mapSeriesMap.set(this._lineSeries.getSerieIndex(), {index:this._lineSeries.getSerieIndex(),color:this._lineSeries.options().color, type:SeriesTypes.PERNAMENT});

              break;

              case(WaveType.INTERMEDIATE):
              this._lineSeries = this.chart.addLineSeries( this.intermediateSerieOptions(wavedirection),0);
            //  this.drawingService.mapSeries.push({index:this._lineSeries.getSerieIndex(),color:this._lineSeries.options().color, type:SeriesTypes.INTERMEDIATE});
              this.drawingService.mapSeriesMap.set(this._lineSeries.getSerieIndex(), {index:this._lineSeries.getSerieIndex(),color:this._lineSeries.options().color, type:SeriesTypes.INTERMEDIATE});
              break;
            }
          }

      if(wavetype!=WaveType.NOWAVE)
      {
        this._lineSeries.setData(data);
      }

    }

    public update(data: LineData)
    {
     try{
        this._lineSeries.update(data);
     }
     catch(e)
     {
       //console.log(e);
     }
    }

    public set(data: LineData[])
    {
     try{
        this._lineSeries.setData(data);
        return this._lineSeries;
     }
     catch(e)
     {
       //console.log(e);
     }
    }

    public get lineSeries():ISeriesApi<"Line">
    {
      return this._lineSeries;
    }

    public static zigzugSerieOptions(lineWidth:number = 10):SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: SerieColor.STANDARD,
        lineStyle: LineStyle.Solid,
        lineWidth:(lineWidth) as LineWidth,
        crosshairMarkerVisible: false,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,
        priceLineColor: SerieColor.PRICELINE,
        priceLineStyle: LineStyle.Solid,

    }
  }

    private standardSerieOptions():SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: SerieColor.STANDARD,
        lineStyle: LineStyle.Solid,
        lineWidth: 1,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: true,
        lastValueVisible: true,
        priceLineColor: SerieColor.PRICELINE,
        priceLineStyle: LineStyle.LargeDashed,

    }
    }

    public static  smaPernamentSerieOptions():SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: SerieColor.STANDARD,
        lineStyle: LineStyle.Solid,
        lineWidth: 1,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,
        priceLineColor: SerieColor.STANDARD,
        priceLineStyle: LineStyle.LargeDashed,

    }
    }

    public static  smaDiffOscillatorSerieOptions():SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: SerieColor.YELLOW,
        lineStyle: LineStyle.Solid,
        lineWidth: 1,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,
        priceLineColor: SerieColor.STANDARD,
        priceLineStyle: LineStyle.LargeDashed,

    }
    }

    public static  smaAddDiffOscillatorSerieOptions():SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: SerieColor.LIGHBLUE,
        lineStyle: LineStyle.SparseDotted,
        lineWidth: 2,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,
        priceLineColor: SerieColor.STANDARD,
        priceLineStyle: LineStyle.LargeDashed,

    }
    }

    public static fibbonaciSerieOptions(color:SerieColor, settings?:lineSettings,isExtended?:boolean,isLong?:boolean, extensionType?:ExtensionType):SeriesPartialOptions<LineStyleOptions>
    {
    //  //console.log(settings.lineStyle);
      return{
        color: color,
        lineStyle: settings.lineStyle,
        lineWidth: settings.lineWidth as LineWidth,
        crosshairMarkerVisible: false,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: true,//isExtended,
        lastValueVisible: false,
        priceLineColor: color,
        priceLineStyle: settings.extendedStyle as LineStyle,
        priceLineWidth: settings.lineWidth as LineWidth,
        priceLineExtended:true,//isExtended,
        priceLineExtendedType: extensionType//(isExtended)?ExtensionType.Right:ExtensionType.None
    }
    }

    public static averagesPanSerieOptions(color:SerieColor):SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: color,
        lineStyle: LineStyle.Solid,
        lineWidth: 1,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,
        priceLineColor: SerieColor.STANDARD,
        priceLineStyle: LineStyle.LargeDashed,

    }
    }

    public static transparentSerieOptions():SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: SerieColor.STANDARD,
        lineStyle: LineStyle.NOLINE,
        lineWidth: 1,
        crosshairMarkerVisible: false,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,
        priceLineColor: SerieColor.PRICELINE,
        priceLineStyle: LineStyle.LargeDashed,

    }
    }

    private intermediateSerieOptions(direction:WaveDirection):SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: (direction == WaveDirection.UP)?SerieColor.UP:SerieColor.DOWN,
        lineStyle: LineStyle.SparseDotted,
        lineWidth: Math.floor(0.5*this._pernamentLineWidth) as LineWidth,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,

    }
    }

    public static intermediateSerieSerieOptions(w):SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color:SerieColor.STANDARD,
        lineStyle: LineStyle.SparseDotted,
        lineWidth: Math.floor(0.5&w) as LineWidth,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,

    }
    }

    public static backgroundSerieSerieOptions(w):SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color:SerieColor.GREYED,
        lineStyle: LineStyle.Solid,
        lineWidth: Math.floor(0.5&w) as LineWidth,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 2,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,

    }
    }

    private pernamentSerieOptions(direction:WaveDirection):SeriesPartialOptions<LineStyleOptions>
    {
      return{
        color: (direction == WaveDirection.UP)?SerieColor.UP:SerieColor.DOWN,
        lineStyle: LineStyle.Dashed,
        lineWidth:  (this._pernamentLineWidth) as LineWidth,
        crosshairMarkerVisible: true,
        crosshairMarkerRadius: 6,
        lineType: LineType.Simple,
        priceLineVisible: false,
        lastValueVisible: false,
    }
    }




}


export enum SerieColor
{
  UP = "#00FF00",
  DOWN = "#ff0000",
  UPZIGZAG = "#1b6ede",
  DOWNZIGZAG = "#e615c6",
  LIGHBLUE = "#00FFFF",
  STANDARD = "#FFFFFF",
  YELLOW = "#FFFF00",
  GREYED = "#838383",
  PRICELINE = "#FFFF00",
  AVGDOWN = "#f6d262",
  AVGUP = "#4781e0",
  AVGDIFF = "#bf05bf",
  INTERUP = "#00dfff",
  INTERDOWN = "#fffb02",
  GTRACKEUP = "rgba(158,250,76,0.7)",
  GTRACKEDOWN= "rgba(250,76,89,0.7)"
}


